import TenantFeatureTable from './TenantFeatureTable'

interface TenantFeaturesCardProps {
  tenantId: string
  tenantName: string
}

export default function TenantFeaturesCard({ tenantId, tenantName }: TenantFeaturesCardProps) {
  return (
    <div className="card">
      <div className="border-b border-gray-200 px-6 py-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Feature Access
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Manage feature overrides and view inherited access from plan and attestations.
        </p>
      </div>

      <div className="p-6">
        <TenantFeatureTable tenantId={tenantId} tenantName={tenantName} />
      </div>
    </div>
  )
}
